/**
 * Compact odd chip for use in accordion headers or tight layouts.
 * Shows a short label and the odd value in a small box.
 * When oddsFormat is provided, uses printOdd for display; otherwise uses decimal toFixed(2).
 */
import React from 'react';
import { cn } from 'lib/utils';
import { printOdd } from 'shared/utils/common';

function CompactOddChip({ odd, label, title, oddsFormat, isSelected = false }) {
  const raw = odd != null ? Number(odd) : null;
  const text = oddsFormat != null && oddsFormat !== ''
    ? (Number.isFinite(raw) ? printOdd(raw, oddsFormat) : '-')
    : (Number.isFinite(raw) ? raw.toFixed(2) : '-');
  return (
    <span
      className={cn(
        'inline-flex flex-col items-center justify-center min-w-[2.25rem] px-1.5 py-0.5 rounded border transition-all',
        isSelected
          ? 'border-transparent bg-[var(--sport-color-hover)] text-[var(--sport-on-color)] shadow-sm'
          : 'border-border bg-background/80 text-foreground'
      )}
      title={title ?? label}
    >
      <span
        className={cn(
          'text-2xs leading-tight truncate max-w-[3rem]',
          isSelected ? 'text-[var(--sport-on-color)]/80' : 'text-muted-foreground'
        )}
      >
        {label}
      </span>
      <span className="text-xs font-semibold">{text}</span>
    </span>
  );
}

export default CompactOddChip;
